import { __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/register/endOfDay/types.ts
var START_EOD_PROCESS = "START_EOD_PROCESS";
var END_EOD_PROCESS = "END_EOD_PROCESS";
var EOD_CLEAR_STATE = "EOD_CLEAR_STATE";
var EOD_SET_STEP_ACTIVE = "EOD_SET_STEP_ACTIVE";
var EOD_ENABLE_STEP = "EOD_ENABLE_STEP";
var EOD_UPDATE_STEP = "EOD_UPDATE_STEP";
var EODSteps = /* @__PURE__ */ ((EODSteps2) => {
  EODSteps2["OPEN_ORDERS"] = "openOrders";
  EODSteps2["NON_CASH_TIPS"] = "nonCashTips";
  EODSteps2["CASH"] = "cash";
  EODSteps2["CASH_TIPS"] = "cashTips";
  EODSteps2["PENDING_ORDERS"] = "pendingOrders";
  EODSteps2["DRAWERS_SETTLEMENT"] = "drawersSettlement";
  EODSteps2["CLOCK_OUT"] = "clockOut";
  return EODSteps2;
})(EODSteps || {});
var CASH_INITIAL_STATE = {
  cashFromOrders: 0,
  paidIn: 0,
  paidOut: 0,
  nonCashTipsEarned: 0,
  cashDueToRestaurant: 0,
  settledTime: "",
  isFetched: false
};
var CASH_TIPS_INITIAL_STATE = {
  cashTips: 0,
  reportedTime: ""
};
var END_OF_DAY_INITIAL_STATE = {
  isEndOfDayActive: false,
  steps: {
    ["openOrders" /* OPEN_ORDERS */]: {
      isActive: false,
      isCompleted: false,
      isDisabled: false
    },
    ["nonCashTips" /* NON_CASH_TIPS */]: {
      isActive: false,
      isCompleted: false,
      isDisabled: true
    },
    ["cash" /* CASH */]: {
      isActive: false,
      isCompleted: false,
      isDisabled: true,
      data: __spreadValues({}, CASH_INITIAL_STATE)
    },
    ["cashTips" /* CASH_TIPS */]: {
      isActive: false,
      isCompleted: false,
      isDisabled: true,
      data: __spreadValues({}, CASH_TIPS_INITIAL_STATE)
    },
    ["pendingOrders" /* PENDING_ORDERS */]: {
      isActive: false,
      isCompleted: false,
      isDisabled: true
    },
    ["drawersSettlement" /* DRAWERS_SETTLEMENT */]: {
      isActive: false,
      isCompleted: false,
      isDisabled: false
    },
    ["clockOut" /* CLOCK_OUT */]: {
      isActive: false,
      isCompleted: false,
      isDisabled: true
    }
  }
};

export { CASH_INITIAL_STATE, CASH_TIPS_INITIAL_STATE, END_EOD_PROCESS, END_OF_DAY_INITIAL_STATE, EODSteps, EOD_CLEAR_STATE, EOD_ENABLE_STEP, EOD_SET_STEP_ACTIVE, EOD_UPDATE_STEP, START_EOD_PROCESS };
